import styled from 'styled-components'

import crossIcon from 'assets/images/femi-cross.svg'

import { FemiColor } from '../../constants'
import { FemiDescription, FemiTitle } from '../../styles'

export const StyledFemiCancelConfirmation = {
  Title: styled(FemiTitle)`
    margin-bottom: 16px;
    font-weight: 500;
  `,
  Description: styled(FemiDescription)`
    margin-bottom: 24px;
  `,
  Losses: styled.ul`
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 29px;
  `,
  Loss: styled.li`
    display: flex;
    gap: 12px;
    color: ${FemiColor.BLACK};
    font-size: 17px;
    font-weight: 400;
    line-height: 26px;

    &::before {
      content: '';
      flex-shrink: 0;
      width: 24px;
      height: 24px;
      margin-top: 1px;
      border-radius: 50%;
      background-color: ${FemiColor.PINK_LIGHT};
      background-image: url(${crossIcon});
      background-position: center;
      background-repeat: no-repeat;
    }
  `,
  Buttons: styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
  `,
}
